import { render, staticRenderFns } from "./DocInfoCard.vue?vue&type=template&id=6c677097&lang=pug"
import script from "./DocInfoCard.vue?vue&type=script&lang=js"
export * from "./DocInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports